import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SharedModule} from '../../app-common/shared.module';
import {ImagesCarouselComponent} from './images-carousel/images-carousel.component';
import {CommonModule} from '@angular/common';
import {UiIconComponent} from '../ui/ui-icon/ui-icon.component';

@NgModule({
  providers: [],
  imports: [RouterModule, SharedModule, CommonModule, UiIconComponent],
  declarations: [ImagesCarouselComponent],
  exports: [],
})
export class ImagesCarouselModule {}
